import { DefaultService } from '@/services/DefaultService';


export default class AssAreaInteresseClienteService extends DefaultService {
  constructor(http, router, env) {
    super(http, router, env);
  }

  findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/cli-areainteresse.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/agro/cliente/cli-areainteresse.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
  }

  updateSituacaoVendas(assareainteressecliente) {
    return this._http.post(`${this._env}/ven/cliente/cli-areainteresse/updatesituacao`, assareainteressecliente, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  updateSituacaoAgro(assareainteressecliente) {
    return this._http.post(`${this._env}/agro/cliente/cli-areainteresse/updatesituacao`, assareainteressecliente, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/cli-areainteresse/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/agro/cliente/cli-areainteresse/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  saveVendas(lista) {
    return this._http.post(`${this._env}/ven/cliente/cli-areainteresse`, lista, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }
  saveAgro(lista) {
    return this._http.post(`${this._env}/agro/cliente/cli-areainteresse`, lista, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }
}